import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfig } from '../../core/api-config';
import { CustomerProfileModel } from '../../core/models';

// Customer profile service.
@Injectable({ providedIn: 'root' })
export class CustomerService {
  constructor(private http: HttpClient) {}
  getProfile(): Observable<CustomerProfileModel> { return this.http.get<CustomerProfileModel>(`${ApiConfig.baseUrl}/customers/my-profile`); }
  updateProfile(model: CustomerProfileModel): Observable<any> { return this.http.post<any>(`${ApiConfig.baseUrl}/customers/my-profile`, model); }
}
